<template>
  <div>
    <div v-loading="is_loading">
      <HeaderSteps :title="name" :dialog="false" :back-path="{ name: 'view-campaign' }">
        <div slot="status"><CampaignStatus :status="flight?.status" /></div>
        <template slot="action-menu">
          <ActionMenu
            :campaign="campaign"
            :flight="flight"
            :circle="true"
            :redirectTo="{ name: 'view-campaign', params: { id: $route.params.id } }"
          />
        </template>

        <template slot="tabs">
          <div class="flex items-center justify-center gap-1">
            <RouterLink :to="{ name: 'view-flight-assets' }" class="menuItem"> Assets </RouterLink>
            <RouterLink :to="{ name: 'view-flight-creatives' }" class="menuItem"> Creatives </RouterLink>
            <RouterLink :to="{ name: 'view-flight-screenshots' }" class="menuItem"> Screenshots </RouterLink>
            <RouterLink :to="{ name: 'view-flight-notes' }" class="menuItem"> Notes </RouterLink>
            <RouterLink :to="{ name: 'view-flight-analytics' }" class="menuItem"> Analytics </RouterLink>
          </div>
        </template>
        <template slot="actions">
          <CtaHeaderActions :campaign="campaign" :isFlightPage="true" />
        </template>
      </HeaderSteps>
      <div class="flex flex-wrap Page__scrollable-content">
        <!-- summary col -->
        <div class="w-1/5 sticky top-0 h-full">
          <FlightSummary />
        </div>
        <!-- end summary col -->
        <!-- content col -->
        <div class="w-4/5 py-3">
          <RevisionRequested v-if="$SBCampaignStatusAccess(['revision'], flightStatus)" :comment="revisionReqDetails" />
          <div class="w-full h-full pr-3">
            <RouterView class="Campaigns--child Loading__target h-full" />
          </div>
        </div>
        <!-- end content col -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { FormatDate } from '@/utils'
import HeaderSteps from '@/components/social-products/social-boost/parts/HeaderSteps.vue'
import CampaignStatus from '@/components/social-products/social-boost/parts/CampaignStatus.vue'
import FlightSummary from '@/components/social-products/social-boost/parts/FlightSummary.vue'
import CtaHeaderActions from '@/components/social-products/social-boost/parts/CtaHeaderActions.vue'
import ActionMenu from '@/components/social-products/social-boost/parts/FlightCard/ActionMenu.vue'
import RevisionRequested from '@/components/social-products/social-boost/parts/RevisionRequested.vue'
import ClearDataMixin from '@/mixins/social-products/ClearData.js'

export default {
  mixins: [ClearDataMixin],
  components: {
    HeaderSteps,
    CampaignStatus,
    FlightSummary,
    CtaHeaderActions,
    ActionMenu,
    RevisionRequested,
  },
  data() {
    return {
      summaryData: {},
      isLoading: false,
    }
  },
  created() {
    this.init()
  },
  computed: {
    ...mapGetters('socialBoostCampaign', ['campaign']),
    ...mapGetters('app', ['is_loading']),
    flight() {
      return this.campaign?.flights?.find((f) => f.id === Number(this.$route.params.flight_id))
    },
    flightStatus() {
      return this.flight?.status
    },
    period() {
      if (this.flight?.start_date && this.flight?.end_date) {
        return `${FormatDate(this.flight.start_date, this.flight.end_date)}`
      }
      return '-'
    },
    name() {
      return this.flight?.name || this.period
    },
    revisionReqDetails() {
      return this.flight?.revision_requested_details?.comment || false
    },
  },
  methods: {
    async init() {
      this.isLoading = true
      await this.$store.dispatch('socialBoostCampaign/getCampaign', { id: this.$route.params.id })
      this.isLoading = false
    },
  },
}
</script>
<style lang="scss" scoped>
.menuItem {
  @apply text-dark font-bold border-b-2 border-transparent px-2 py-1 hover:text-primary;
  &.router-link-active {
    @apply border-primary text-primary;
  }
}
</style>
